export default __webpack_public_path__ + "static/media/4-mobile.f49420c1.png";